import { Box, Container, Grid, Header } from '@amzn/awsui-components-core';
import React from 'react';
import { useFinTechContext } from 'src/components/context/FintechContextProvider';
import { LoadingSpinner } from 'src/components/generic-components/LoadingSpinner';
import { numberFormatter } from 'src/utilities/CommonUtilities';
import { FinOpsTable } from '../fintech-ops-table/FinOpsTable';
import { ErrorContainer, NotInitializedContainer } from '../FinTechOpsCommonElements';
import { useDogmaContext } from './DogmaContext';
import styles from './styles.module.scss';

export const DogmaDetailsPage: React.FC = () => {
  const finOpsContext = useFinTechContext();
  const dogmaContext = useDogmaContext();

  return (
    <div>
      {finOpsContext?.finTechOpsPolicyEngineDataStatus == 'loading' && <LoadingSpinner />}
      {finOpsContext?.finTechOpsPolicyEngineDataStatus == 'error' && <ErrorContainer />}
      {finOpsContext?.finTechOpsPolicyEngineDataStatus == 'pending' && <NotInitializedContainer />}
      {finOpsContext?.finTechOpsPolicyEngineDataStatus == 'finished' && (
        <Grid
          gridDefinition={[
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 4, l: 3, xl: 4 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 8, l: 9, xl: 8 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } },
            { colspan: { default: 12, xxs: 12, xs: 12, s: 12, m: 12, l: 12, xl: 12 } }
          ]}
        >
          <Container fitHeight header={<Header variant="h2">Total Open Violations</Header>}>
            <Box variant="h3" textAlign="center">
              {numberFormatter(dogmaContext?.dogmaDetailsTabData?.dogmaSummaryContainer?.dogmaOpenRiskCount)}
            </Box>
            <div className={styles.DogmaDetailsTable}>
              <FinOpsTable
                pageSize={4}
                emptyMessage="No dogma data to display"
                filterProperties={[]}
                visibleContent={dogmaContext?.dogmaDetailsTabData?.dogmaSummaryContainer?.dogmaSummaryTable?.visibleColumns}
                columnDefinitions={dogmaContext?.dogmaDetailsTabData?.dogmaSummaryContainer?.dogmaSummaryTable?.columnData}
                data={dogmaContext?.dogmaDetailsTabData?.dogmaSummaryContainer?.dogmaSummaryTable?.rowData}
                headerName=""
              />
            </div>
          </Container>
          <Container fitHeight>
            <div className={styles.DogmaDetailsTable}>
              <FinOpsTable
                pageSize={100}
                stickyHeader={false}
                emptyMessage="No dogma data to display"
                filterProperties={[]}
                visibleContent={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByManager?.visibleColumns}
                columnDefinitions={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByManager?.columnData}
                data={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByManager?.rowData}
                headerName="Total Aggregated Violations by Manager"
              />
            </div>
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={4}
              stickyHeader={false}
              emptyMessage="No dogma data to display"
              filterProperties={[]}
              visibleContent={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationsByRiskSeverity?.visibleColumns}
              columnDefinitions={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationsByRiskSeverity?.columnData}
              data={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationsByRiskSeverity?.rowData}
              headerName="Total Open Violations by Risk severity"
            />
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={4}
              stickyHeader={false}
              emptyMessage="No dogma data to display"
              filterProperties={[]}
              visibleContent={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByRiskSeverity?.visibleColumns}
              columnDefinitions={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByRiskSeverity?.columnData}
              data={dogmaContext?.dogmaDetailsTabData?.totalAggregatedViolationsByRiskSeverity?.rowData}
              headerName="Total Aggregated Violations by Risk Severity"
            />
          </Container>
          <Container fitHeight>
            <FinOpsTable
              pageSize={10}
              stickyHeader={false}
              emptyMessage="No dogma data to display"
              filterProperties={[]}
              visibleContent={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationDetails?.visibleColumns}
              columnDefinitions={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationDetails?.columnData}
              data={dogmaContext?.dogmaDetailsTabData?.totalOpenViolationDetails?.rowData}
              headerName="Total Open Violation Details"
            />
          </Container>
        </Grid>
      )}
    </div>
  );
};
